import { faBars, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
const AdminNavbar = ({ onToggleSidebar }) => {
    const { logout } = useAuth();
    
    return (
        <Navbar expand="lg" className="admin-navbar">
            <Container fluid>
                <Navbar.Brand as={Link} to="/bj-admin" className="admin-navbar-brand">
                    <button
                        type="button"
                        className="sidebar-toggle-btn"
                        onClick={(e) => {
                            e.preventDefault();
                            if (onToggleSidebar) {
                                onToggleSidebar();
                            }
                        }}
                        aria-label="Toggle sidebar"
                    >
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                    BJ Admin Panel
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Dropdown>
                            <Dropdown.Toggle className="admin-user-dropdown">
                                <FontAwesomeIcon size="24" icon={faUserCircle} /> User
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="end">
                                {/* <Dropdown.Item as={Link} to="/admin/profile">
                                    Profile
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/admin/settings">
                                    Settings
                                </Dropdown.Item> */}
                                {/* <Dropdown.Divider /> */}
                                <Dropdown.Item
                                    onClick={() => {
                                        logout();
                                    }}
                                >
                                    Logout
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AdminNavbar;
